<template>
<div class="title-wrapper" v-if="title !== ''">
	<a v-if="elementStyle === 'mainTitle'"><div class="mainTitle ql-editor" :style="titleStyle" v-html="title"></div></a>
	<div v-if="elementStyle === 'subTitle'" class="subTitle ql-editor" :style="titleStyle" v-html="title"></div>
</div>
</template>

<script>
export default {
  props: {
    elementStyle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    defaultFont: {
      type: String,
      default: 'inherit'
    }
  },
  computed: {
    titleStyle() {
      return {
        'font-family': this.defaultFont
      }
    }
  }
}
</script>
<style scoped>
  .mainTitle {
    font-size: 1.5em;
  }
  .subTitle {
    font-size: 1.3em;
  }
	.title-wrapper{
		padding: 10px 15px!important;
	}
	.ql-editor {
		padding: 0;
    overflow-y: unset;
	}
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Title.vue